import styled from "styled-components";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import Small from "../../atoms/typography/Small";
import type { RuleModel } from "../../../models/AmlRiskScoreModel";

interface Props {
  rulesWithHits: Array<RuleModel>;
  clientIdentifier: string;
}

const BadgeContainer = styled.div<{ color: string; clickable?: boolean }>`
  background-color: ${(props) => props.color};
  padding: 2px 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  width: fit-content;
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};
`;

const BadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  row-gap: 4px;
`;

const RiskScoreHitBadge: React.FC<Props> = ({
  rulesWithHits,
  clientIdentifier,
}) => {
  const { t } = useTranslation();

  const getColor = (hit: string) => {
    switch (hit) {
      case "RULE_CASH_INTENSIVE_BUSINESS":
        return theme.colors.warning05;
      case "RULE_NEW_CUSTOMER_MARKING":
        return theme.colors.primary20;
      case "RULE_COMPLEX_OWNERSHIP_STRUCTURE":
        return theme.colors.info05;
      case "RULE_CUSTOMER_FIPO_MARKING":
        return theme.colors.error20;
      case "RULE_COUNTRY_RELATIONS":
        return theme.colors.grey4;
      case "RULE_HIGH_RISK_INDUSTRY":
        return theme.colors.warning05;
      case "RULE_HISTORICAL_BANKRUPTCIES_CORPORATE_REPRESENTATIVES":
        return theme.colors.error05;
      case "RULE_ON_SITE_MEETING_OCCURED":
        return theme.colors.success20;
      case "RULE_POLITICALLY_EXPOSED_PERSONS":
        return theme.colors.success05;
      case "RULE_DEBT_BALANCE":
        return theme.colors.info20;
      case "RULE_INTERNAL_KYC_CUSTOMER_SERVICES":
        return theme.colors.bgSubtle;
      case "RULE_NON_TRIVIAL_EXPOSURE_INDUSTRY_CODE_RISK":
        return theme.colors.disabled;
      case "RULE_VERIFIERA_COMPANY_REPRESENTATIVES":
        return theme.colors.error20;
      default:
        return theme.colors.info05;
    }
  };

  return (
    <BadgesWrapper>
      {rulesWithHits.map((hit) => (
        <BadgeContainer
          key={`${hit.id}${clientIdentifier}`}
          color={getColor(hit.type)}
        >
          <Small color={theme.colors.black} fontweight={400}>
            {t(`aml.riskScoreTitles.${hit.type}`)}
          </Small>
        </BadgeContainer>
      ))}
    </BadgesWrapper>
  );
};

export default RiskScoreHitBadge;
